export default __webpack_public_path__ + "static/media/Scratch.26865426.webp";